export default {
	APP_ID: process.env.APP_ID ?? "",
	TOKEN: process.env.APP_TOKEN ?? "",
};
